import React from 'react';
import DataTable from './DataTable/DataTable';

function CovidDashboard(){
    return <DataTable/>
}

export default CovidDashboard;